document.addEventListener('DOMContentLoaded', function () {
    const currentPath = window.location.pathname;
    const menuItems = document.querySelectorAll('.header__nav ul li a'); // Знайдемо всі посилання в меню

    menuItems.forEach(function (menuItem) {
        const parentItem = menuItem.closest('li'); // Знайдемо батьківський елемент 'li'
        const menuItemHref = menuItem.getAttribute('href');

        // Перевіряємо чи це заглушка
        if (menuItemHref === '#') {
            // Якщо це заглушка, перевіряємо дочірні елементи 2-го рівня
            const childMenuItems = parentItem.querySelectorAll('ul > li > a'); // Перевіряємо тільки прямі дочірні елементи

            childMenuItems.forEach(function (childMenuItem) {
                const childHref = childMenuItem.getAttribute('href');

                // Видаляємо все після першого слеша після базового шляху для порівняння
                const baseHref = childHref;

                // Перевіряємо дочірні елементи 2-го рівня
                if (currentPath === baseHref) {
                    parentItem.classList.add('hover'); // Підсвічуємо батьківський пункт, якщо будь-який дочірній елемент активний
                    return; // Якщо знайшли активний елемент, припиняємо подальшу перевірку
                }

                // Перевіряємо дочірні елементи 3-го рівня
                const thirdLevelMenuItems = childMenuItem
                    .closest('li')
                    .querySelectorAll('ul > li > a');

                thirdLevelMenuItems.forEach(function (thirdLevelMenuItem) {
                    const thirdHref = thirdLevelMenuItem.getAttribute('href');
                    const thirdBaseHref = thirdHref.split('/').slice(0, 3).join('/');

                    if (currentPath === thirdBaseHref) {
                        parentItem.classList.add('hover'); // Підсвічуємо батьківський пункт, якщо будь-який 3-й рівень активний
                        return; // Якщо знайшли активний елемент, припиняємо подальшу перевірку
                    }
                });
            });
        } else {
            // Видаляємо все після першого слеша після базового шляху для порівняння
            const baseHref = menuItemHref.split('/').slice(0, 3).join('/');

            // Якщо це не заглушка, перевіряємо точний збіг базового шляху
            if (currentPath === baseHref) {
                parentItem.classList.add('hover'); // Підсвічуємо сам елемент, якщо він активний
            }
        }
    });
});

document.addEventListener('DOMContentLoaded', function () {
    var lang = document.documentElement.lang; // Отримуємо значення атрибута lang
    var engButton = document.querySelector(".language-switcher-button[data-lang='en']");
    var uaButton = document.querySelector(".language-switcher-button[data-lang='uk']");

    // Додаємо активний клас для поточної мови
    if (lang === 'en') {
        engButton.classList.add('active');
    } else if (lang === 'uk') {
        uaButton.classList.add('active');
    }
});
